import deityWorship1 from "../../../assets/images/deity-worship1.jpg";
import deityWorship2 from "../../../assets/images/deity-worship2.jpg";
import deityWorship3 from "../../../assets/images/deity-worship3.jpg";
import deityWorship4 from "../../../assets/images/deity-worship4.jpg";
import deityWorship5 from "../../../assets/images/deity-worship5.jpg";

export const deityWorshipImages = [
  {
    id: 1,
    image: deityWorship1,
  },
  {
    id: 2,
    image: deityWorship2,
  },
  {
    id: 3,
    image: deityWorship3,
  },
  {
    id: 4,
    image: deityWorship4,
  },
  {
    id: 5,
    image: deityWorship5,
  },
];

export const deityWorship = [
  "Deity worship is an important aspect of the spiritual practices at ISKCON Vallabh Vidya Nagar, which is a temple of the International Society for Krishna Consciousness (ISKCON) located in the city of Vallabh Vidya Nagar in Gujarat, India. The temple’s primary deity is Lord Krishna, who is worshiped with great devotion and reverence by the devotees.",

  "The main presiding deities are Sri Sri Radha Giridhariji along with Sri Sri Jagannath Sri Baladev and Shrimati Subhadra Devi.The process of deity worship at ISKCON Vallabh Vidya Nagar is based on the principles of Bhakti-yoga, which emphasizes the importance of developing a personal relationship with God through devotional service. The temple follows strict guidelines for the worship of the deities, which include daily rituals, offerings of food and flowers, and chanting of mantras and prayers.",

  "The deities at ISKCON Vallabh Vidya Nagar are carefully crafted and decorated according to the traditional Vaishnava standards, which require a high degree of skill and expertise. The temple’s pujaris, or priests, are specially trained in the art of deity worship and are responsible for performing the daily rituals and ceremonies.",

  "Devotees at ISKCON Vallabh Vidya Nagar are encouraged to participate in the deity worship by offering their own devotional service, such as chanting the Hare Krishna mantra or assisting in the preparation of offerings. This practice helps to cultivate a sense of personal connection and devotion to the deities, and to deepen one’s understanding of the principles of Bhakti-yoga.",

  "The temple also offers opportunities for visitors to participate in the deity worship through various programs and events, such as the daily arati ceremony, the weekly Sunday Feast, and the annual Janmashtami festival, which celebrates the appearance of Lord Krishna in this world.",

  "Overall, the deity worship at ISKCON Vallabh Vidya Nagar is an integral part of the temple’s spiritual practices, and it serves as a powerful means for cultivating love and devotion to Lord Krishna and deepening one’s spiritual connection to the divine.",
];
